module.exports = __webpack_public_path__ + "static/media/woman_06.9b78e959.png";